import { useMemo } from "react";
import { useGetGeneralsQuery, useGetTeamsQuery } from "../store/api";

export const useGeneralSheetHook = () => {
  const { data, isLoading } = useGetGeneralsQuery("general", {
    refetchOnMountOrArgChange: true,
  });

  const generalData = useMemo(() => {
    if (data && data[0]) {
      return data[0];
    }

    return {
      phone_number_1: "1 433 500 5047",
      phone_number_2: "234 701 979 2256",
      email: "info@conceptmultiservicesnig.com",
      account_number: "0095694286",
      account_name: "Concept Multiservices Nig",
      bank_name: "Sterling Bank",
      zelle_id: "conceptmultiservicesnig@gmail.com",
      cashapp_id: "$Arthureke",
      sheet_micro_url:
        "https://script.google.com/macros/s/AKfycbyYAtnNH1RevRc8qwXBGFOC0XBpfba0D24i08H_6SV6QmyWDjzYnzjMmPQR7Gd7Wjw/exec",
      paystack_public_key: "",
      about_video: "",
      about_video_2: "",
      twitter: "https://x.com",
      youtube: "https://www.youtube.com/@concept_tv",
      instagram:
        "https://www.instagram.com/herosoftomorrow.tv?igsh=czFrZnp3cXQ0eXMz&utm_source=qr",
      facebook:
        "https://web.facebook.com/people/Concept-Multiservices-NIG/61559000030259/",
      address:
        "Suite 139 Magnet Shopping Complex, Agege, Motor Road, Lagos Nigeria",
      contact_form_micro:
        "https://script.google.com/macros/s/AKfycbypYgZ5Tt3v0FFZDoCJDPU428cEYkyVX-Dc0t7VNgw3uTB44aq4rWPhTyfRXmAPbTw/exec",
    };
  }, [data]);

  return {
    ...generalData,
    isLoading: isLoading,
  };
};

export const useTeamSheet = () => {
  const { data, isLoading } = useGetTeamsQuery("team", {
    refetchOnMountOrArgChange: true,
  });

  const teamData = useMemo(() => {
    if (data) {
      return data;
    }

    return [
      {
        id: 1,
        name: "Chief Arthur Eke",
        title: "Chairman / CEO Concept Group",
        image: "/assets/images/team/arthur_eke.png",
        shortBio:
          "Highly accomplished business leader with extensive experience across diverse industries in Nigeria and the United States. Founded Concept Group, a growing conglomerate of multiple businesses.",
        fullBio:
          "Chief Arthur Eke is a highly accomplished business leader with extensive management experience in diverse industries, both in Nigeria and abroad, with a proven track record of driving growth and innovation in various organizations. Prior to founding Concept Group, a conglomerate comprising: Concept Multiservices NIG, Concept Hotels and Spa, Okuko Oma Farms, Heroes of Tomorrow Charity and Founders Approach Digital Services, Chief Eke held key positions in reputable organizations, including: Jetlinks Nigeria as the CISCO Deployment Site Lead, Mara-Ison Technologies as the Senior IT Lead, Avaya Deployment, Airtel Communications Nigeria (IT), Digital Interactive Media (producers of the TV series Next Movie Star) and Surmount Multiservices Limited. After his relocation to the United States, Chief Eke worked with prominent companies, including: Amazon in Maryland Baltimore, Emergent Biosolutions, Southwest Airlines BWI Airport Baltimore International Airport and Catalent Pharma among others. He further enhanced his management expertise through studies at the University of Maryland Global Campus.",
        twitter: "https://twitter.com/",
        facebook: "https://facebook.com/",
        pinterest: "https://pinterest.com/",
        instagram: "https://instagram.com/",
      },
      {
        id: 2,
        name: "Esther Arthur",
        title: "Vice President Concept Group",
        image: "/assets/images/team/esther_arthur.png",
        shortBio:
          "Results-driven executive with strong background in Banking and Finance. Her distinguished career spans multiple industries including Creative Concepts, Delta Airlines and Amazon.",
        fullBio:
          "Mrs. Esther Arthur is a results-driven executive with a strong background in Banking and Finance, and extensive experience in top-tier organizations globally. Her distinguished career spans multiple industries, with notable tenures at Creative Concepts, Delta Airlines and Amazon. As the Vice President of Concept Group, Mrs. Arthur collaborates closely with the Group Chairman to drive strategic decision-making and ensure seamless execution of key initiatives.",
        twitter: "https://twitter.com/",
        facebook: "https://facebook.com/",
        pinterest: "https://pinterest.com/",
        instagram: "https://instagram.com/",
      },
      {
        id: 3,
        name: "Christiana Pwajok",
        title: "Marketing Operations",
        image: "/assets/images/team/christiana_pwajok.png",
        shortBio:
          "Marketing professional with distinguished career across multiple industries. Alumna of Plateau State Polytechnic recognized as a pace-setter in innovative marketing strategies.",
        fullBio:
          "Results-driven marketing professional with a distinguished career spanning multiple industries. A proud alumna of Plateau State Polytechnic, Mrs. Pwajok has built an impressive track record of delivering outstanding results in marketing. Prior to joining Concept Group, she honed her expertise through key roles at renowned organizations, including: Honeywell Group, Grand Cereals Ltd and Oil Mill Limited to name a few. Her achievements have earned her recognition as a pace-setter in marketing, driving innovative strategies and exceptional performance.",
        twitter: "https://twitter.com/",
        facebook: "https://facebook.com/",
        pinterest: "https://pinterest.com/",
        instagram: "https://instagram.com/",
      },
      {
        id: 4,
        name: "Bright Ogu",
        title: "Head, Field Operations",
        image: "/assets/images/team/bright_ogu.png",
        shortBio:
          "Experienced operational leader with a Degree in Business Administration, leveraging expertise as a former Content Analyst to drive efficient field operations.",
        fullBio:
          "An experienced operational leader, Bright Ogu holds a Degree in Business Administration. He leverages his expertise and prior experience as a Content Analyst to drive efficient field operations at Concept Multiservices.",
        twitter: "https://twitter.com/",
        facebook: "https://facebook.com/",
        pinterest: "https://pinterest.com/",
        instagram: "https://instagram.com/",
      },
    ];
  }, [data]);

  return {
    data: teamData,
    isLoading: isLoading,
  };
};
